module.exports = __webpack_public_path__ + "static/img/AU.92498ef1.svg";